import './disclaimers.scss';

import React from 'react';
import { PropTypes } from 'prop-types';
import { i18n } from 'core/i18n';
import classNames from 'classnames';

const { formatText } = i18n;

const Disclaimers = ({ compact, product = false }) => {
    const isCompactKey = compact ? '_compact' : '';

    const className = classNames('brokerIA-disclaimers', {
        'brokerIA-disclaimers--product': product,
    });

    return (
        <div className={className}>
             {!compact && (<div className="brokerIA-disclaimers__heading">
                {formatText(`brokerIA-disclaimers__heading_part1${isCompactKey}`)}
                &nbsp;
                <a
                    className="brokerIA-disclaimers__heading__link"
                    href={formatText(`brokerIA-disclaimers__heading_linkUrl${isCompactKey}`)}
                    target="_blank"
                >
                    {formatText(`brokerIA-disclaimers__heading_textUrl${isCompactKey}`)}
                </a>
                {formatText(`brokerIA-disclaimers__heading_part2${isCompactKey}`)}
            </div>)}
            <div className="brokerIA-disclaimers__text1">
                {formatText(`brokerIA-disclaimers_text1_part1${isCompactKey}`)}
                <a
                    className="brokerIA-disclaimers__link"
                    href={formatText(`brokerIA-disclaimers_linkUrl${isCompactKey}`)}
                    target="_blank"
                >
                    {formatText(`brokerIA-disclaimers_textUrl${isCompactKey}`)}
                </a>
                {formatText(`brokerIA-disclaimers_text1_part2${isCompactKey}`)}
            </div>
            {!product && (
                <div className="brokerIA-disclaimers__text2">
                    {formatText(`brokerIA-disclaimers_text2${isCompactKey}`)}
                </div>
            )}
        </div>
    );
};

Disclaimers.propTypes = {
    compact: PropTypes.Boolean,
    product: PropTypes.Boolean,
};

export default Disclaimers;
